export default __webpack_public_path__ + "static/media/logo-filled.2ec3a333.png";